const mainTheme = {
  palette: {
    primary: {
      light: '#606060',
      main: '#505050',
      dark: '#404040'
    },
  },
};

export default mainTheme;